import TelescopeIcon from './component.jsx'
export default TelescopeIcon
